import { Component, OnInit, OnChanges, Input } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { ProfileService } from '../../shared/profile.service';
import { PhoneType } from '../../shared/model/phone-type.model';
import { ProfilePhone } from '../../shared/model/profile-phone.model';

@Component({
  selector: 'wl-profile-edit-phone-list',
  templateUrl: 'profile-edit-phone-list.component.html',
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditPhoneListComponent),
    CreateObjectValueValidationProvider(ProfileEditPhoneListComponent),
  ],
    standalone: false
})
export class ProfileEditPhoneListComponent extends ObjectValueAccessor<Array<ProfilePhone>> implements OnInit, OnChanges {
  @Input() profileId: number;

  public phoneTypes: Array<PhoneType>;

  public constructor(private _profileService: ProfileService) {
    super([], false);
    this.phoneTypes = new Array<PhoneType>();
  }

  ngOnInit() {
    this._profileService.getPhoneTypes().then(data => {
      this.phoneTypes = data;
    });
  }

  ngOnChanges() {
    if (this.profileId) {
      this._profileService.getProfilePhones(this.profileId).then(data => {
        this.value = data;
        setTimeout(() => {
          this.setPristine();
        }, 500);
      });
    }
  }

  addPhone() {
    this.value.push({} as ProfilePhone);
  }

  deletePhone(index: number) {
    this.value.splice(index, 1);
  }

  save() {
    const unchangedPhones: Array<ProfilePhone> = JSON.parse(this.pristineValue);
    const deletedPhones: Array<ProfilePhone> = unchangedPhones.filter(x => !this.value.some(a => x.ProfilePhoneID == a.ProfilePhoneID));
    const phonePromises: any[] = [];

    for (let phone of this.value) {
      if (phone.ProfilePhoneID > 0) {
        let originalPhone: ProfilePhone = unchangedPhones.find(x => x.ProfilePhoneID == phone.ProfilePhoneID);
        if (originalPhone && JSON.stringify(originalPhone) != JSON.stringify(phone)) {
          phonePromises.push(this._profileService.updateProfilePhone(phone));
        }
      }

      if (!phone.ProfilePhoneID) {
        phone.ProfileID = this.profileId;
        phonePromises.push(
          this._profileService.createProfilePhone(phone).then(data => {
            phone.ProfilePhoneID = data;
          })
        );
      }
    }

    for (let phone of deletedPhones) {
      phonePromises.push(this._profileService.deleteProfilePhone(phone.ProfilePhoneID));
    }

    return Promise.all(phonePromises).then(() => {
      this.setPristine();
    });
  }
}
